<ng-container *ngIf="type == 'view-search'">
    <div class="min-w-[300px] max-w-[300px] mt-2">
        <nz-input-group [nzSuffix]="suffixIcon">
            <input type="text" nz-input placeholder="Search location..." ngModel
                (ngModelChange)="search.next($event)" />
        </nz-input-group>
        <ng-template #suffixIcon>
            <span nz-icon nzType="search" class="text-gray-400"></span>
        </ng-template>

        <div class="max-h-[500px] mt-2 overflow-auto no-scrollbar">
            <ng-container *ngIf="treeControl.dataNodes.length > 0; else noData">
                <nz-tree-view [nzTreeControl]="treeControl" [nzDataSource]="dataSource" [trackBy]="trackBy"
                    nzNoAnimation>
                    <!-- Leaf node -->
                    <nz-tree-node *nzTreeNodeDef="let node" nzTreeNodeIndentLine>
                        <nz-tree-node-option [nzDisabled]="node.disabled" [nzSelected]="selectedNode.isSelected(node)"
                            (nzClick)="onNodeSelection(node)"
                            class="group hover:bg-blue-50 rounded transition-colors duration-100 px-3 py-1.5 text-sm text-gray-700 cursor-pointer">
                            <span class="flex items-center gap-2">
                                <i nz-icon nzType="hezky:Location"
                                    class="text-blue-400 text-lg group-hover:text-blue-500"></i>
                                <span [innerHTML]="node.title | nzHighlight: searchValue : 'i' : 'highlight'"
                                    class="truncate font-normal"></span>
                            </span>
                        </nz-tree-node-option>
                    </nz-tree-node>

                    <!-- Parent node -->
                    <nz-tree-node *nzTreeNodeDef="let node; when: hasChild" nzTreeNodeIndentLine>
                        <nz-tree-node-toggle>
                            <i nz-icon nzType="caret-down"
                                class="text-gray-400 text-sm mr-0.5 group-hover:text-blue-400 transition-colors duration-100"
                                nzTreeNodeToggleRotateIcon></i>
                        </nz-tree-node-toggle>
                        <nz-tree-node-option [nzDisabled]="node.disabled" [nzSelected]="selectedNode.isSelected(node)"
                            (nzClick)="onNodeSelection(node)"
                            class="text-sm text-gray-900 font-semibold cursor-pointer p-2">
                            <span class="flex items-center gap-2">
                                <i *ngIf="node.level !== 0" nz-icon
                                    class="text-blue-500 text-lg group-hover:text-blue-600"
                                    nzType="hezky:Location_Group" nzTheme="outline"></i>
                                <span [innerHTML]="node.title | nzHighlight: searchValue : 'i' : 'highlight'"
                                    class="truncate"></span>
                            </span>
                        </nz-tree-node-option>
                    </nz-tree-node>
                </nz-tree-view>
            </ng-container>
            <ng-template #noData>
                <div class="flex items-center justify-center gap-x-2 h-full">
                    <i nz-icon nzType="folder-open" nzTheme="outline" class="text-gray-300"></i>
                    <h3 class="text-gray-500">No location found</h3>
                </div>
            </ng-template>
        </div>
    </div>
</ng-container>